const handleResponse = (response: any, isFormSave = false): ApiResponse => {
    if(isFormSave) {
        const body = JSON.parse(response.data.d);
        if(body && body.Status == 'success') {
            const data = JSON.parse(body.RedirectUrl);
            return {
                error: undefined,
                invalid: false,
                validationErrors: [],
                success: true,
                data: data
            }
        } else if (body && body.Status == 'invalid') {
            const validationErrors: Array<ValidationError> = [];
            if(body.Errors && body.Errors.length) {
                for (const list of body.Errors) {
                    for(const err of list) {
                        validationErrors.push({
                            field: err.Message,
                            message: `genericValidation.${err.ValidationErrorType}`
                        });
                    }
                }
            }
            return {
                error: undefined,
                invalid: true,
                validationErrors: validationErrors,
                success: false,
                data: {}
            }
        } else {
            let error;
            if(body.Errors && body.Errors.length) {
                error = body.Errors[0][0].Message;
            }
            return {
                error: error || "errors.unknown",
                invalid: false,
                validationErrors: [],
                success: false,
                data: {}
            }
        }
    } else {
        const data = JSON.parse(response.data.d);
        return {
            invalid: false,
            validationErrors: [],
            success: true,
            data: data
        }
    }
}

const generateValidationSummary = (errors: any): ValidationError[] => {
    const validationErrors = [] as ValidationError[];
    for (const [key, value] of Object.entries(errors)){
        validationErrors.push({
            field: key.replace(/\[\d+\]/g, '[]'),
            message: value as string =='validation.required' ? 'genericValidation.required' : 'genericValidation.invalid'
        });
    }
    return validationErrors;
}

const scrollTop = () => {
    const w = window as any;
    w.$('html, body').animate({
        scrollTop: w.$('#app').last().offset().top
    }, 500);
}

type ApiResponse = {
    error?: string,
    invalid: boolean,
    validationErrors: Array<ValidationError>,
    success: boolean,
    data: any
}

type ValidationError = {
    field: string,
    message: string
}

export { handleResponse, generateValidationSummary, scrollTop }
export type { ApiResponse, ValidationError}